var map = {
	"./admin-stg/admin-stg.png": 89322,
	"./admin/admin.png": 28846,
	"./boat-stg/boat-stg.png": 37006,
	"./boat/boat.png": 30280,
	"./bpcl-stg/bpcl-stg.png": 16868,
	"./bpcl/bpcl.png": 17146,
	"./central/central.png": 26666,
	"./crompton-stg/crompton-stg.png": 1238,
	"./crompton/crompton.png": 60936,
	"./cropton-stg/crompton-stg.png": 30049,
	"./eseal-ecs-lb-486270027-stg/eseal-ecs-lb-486270027-stg.png": 75430,
	"./eseal-ecs-lb-486270027/eseal-ecs-lb-486270027.png": 16176,
	"./finolex-stg/finolex-stg.png": 95286,
	"./finolex/finolex.png": 72918,
	"./icapidilite-stg/icapidilite-stg-description.png": 14043,
	"./icapidilite-stg/icapidilite-stg.png": 71814,
	"./icapidilite-stg/icapidilite.png": 38349,
	"./icapidilite/icapidilite-description.png": 38755,
	"./icapidilite/icapidilite.png": 62078,
	"./icapidilite/icapidilite1.png": 75749,
	"./mango-stg/mango-stg.png": 74014,
	"./mango/mango.png": 45774,
	"./orient-stg/orient-stg.png": 15548,
	"./orient/orient.png": 45046,
	"./pidilite-stg/pidilite-stg.png": 48794,
	"./pidilite/pidilite.png": 44836,
	"./product-stg/product-stg.png": 96562,
	"./product/product.png": 95726,
	"./sudhakar-stg/sudhakar-stg.png": 11420,
	"./sudhakar/sudhakar.png": 54614,
	"./valvoline-stg/valvoline-stg.png": 31710,
	"./valvoline/valvoline.png": 65938,
	"./vguard-bt/vguard-bt.png": 26550,
	"./vguard-stg/vguard-stg.png": 67376,
	"./vguard/vguard.png": 78390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32648;